var React = require('react');

function TableQuote (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 17.6H7.08955L9.0398 7H2.95025L1 17.6ZM8.9602 17.6H15.0497L17 7H10.9104L8.9602 17.6Z","fill":"#FF04D5"}));
}

TableQuote.defaultProps = {"width":"18","height":"26","viewBox":"0 0 18 26","fill":"none"};

module.exports = TableQuote;

TableQuote.default = TableQuote;
